import { useMutation } from "@tanstack/react-query";
import { z } from "zod";
import { useTRPC } from "@/lib/trpc";

export const createTaskFormSchema = z.object({
    title: z.string().min(1, "Task title is required").max(500, "Task title cannot exceed 50 characters"),
    task_lists: z.array(z.number()),
});

export const useCreateCustomAttributeMutation = () => {
    const trpc = useTRPC();
    return useMutation(
        trpc.customAttributes.insert.mutationOptions({
            onSuccess: async (_, _vars, _on, context) => {
                context.client.invalidateQueries({ queryKey: trpc.customAttributes.list.pathKey() });
                context.client.invalidateQueries({ queryKey: ["attributes"] }); // everything below attributes
            },
        })
    );
};

export const useUpdateCustomAttributeMutation = () => {
    const trpc = useTRPC();
    return useMutation(
        trpc.customAttributes.update.mutationOptions({
            onSuccess: async (_, _vars, _on, context) => {
                context.client.invalidateQueries({ queryKey: trpc.taskList.getPreferences.pathKey() }); // it's possible the attribute is used in a visible list
                context.client.invalidateQueries({ queryKey: trpc.customAttributes.list.pathKey() });
                context.client.invalidateQueries({ queryKey: ["attributes"] }); // everything below attributes
            },
        })
    );
};

export const updateTaskStatusOrderMutation = () => {
    const trpc = useTRPC();

    // we don't need to invalidate anything since we already persisted the order in local state (TaskListSection)
    const opts = trpc.taskStatus.updateOrder.mutationOptions({
        onSuccess: async (_, _vars, _on, context) => {
            context.client.invalidateQueries({ queryKey: trpc.taskStatus.list.pathKey() });
        },
    });

    return useMutation(opts);
};

export const useDeleteCustomAttributeMutation = () => {
    const trpc = useTRPC();
    return useMutation(
        trpc.customAttributes.delete.mutationOptions({
            onSuccess: async (_, _vars, _on, context) => {
                context.client.invalidateQueries({ queryKey: trpc.taskList.getPreferences.pathKey() }); // it's possible the attribute is used in a visible list
                context.client.invalidateQueries({ queryKey: trpc.customAttributes.list.pathKey() });
                context.client.invalidateQueries({ queryKey: ["attributes"] }); // everything below attributes
            },
        })
    );
};

export const useCreateTaskStatusMutation = () => {
    const trpc = useTRPC();
    return useMutation(
        trpc.taskStatus.insert.mutationOptions({
            onSuccess: async (_, _vars, _on, context) => {
                context.client.invalidateQueries({ queryKey: trpc.taskStatus.list.pathKey() });
            },
        })
    );
};

export const useUpdateTaskStatusMutation = () => {
    const trpc = useTRPC();
    return useMutation(
        trpc.taskStatus.update.mutationOptions({
            onSuccess: async (_, _vars, _on, context) => {
                context.client.invalidateQueries({ queryKey: trpc.taskStatus.list.pathKey() });
            },
        })
    );
};

export const useDeleteTaskStatusMutation = () => {
    const trpc = useTRPC();
    return useMutation(
        trpc.taskStatus.delete.mutationOptions({
            onSuccess: async (_, _vars, _on, context) => {
                context.client.invalidateQueries({ queryKey: trpc.taskStatus.list.pathKey() });
            },
        })
    );
};
